import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { formatDinero } from '../../utils/formatDinero';
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
)
const options = {
    plugins: {
        datalabels: {
            formatter: (value) => {
                if (value < 15) return '';
                return value;
            },
        },

        tooltip: {
            callbacks: {
                label: function (context) {
                    let label = '';
                    if (context.parsed !== null) {
                        label += formatDinero(context.parsed.y)
                    }
                    return label
                }
            }
        }
    },
    responsive: true,
    interaction: {
        mode: 'index',
        intersect: false,
    },
    scales: {
        x: {
            stacked: true,
        },
        y: {
            stacked: true,
            ticks: {
                callback: function (label) {
                    return formatDinero(label)
                }
            }
        },
    },
}
const GraficaBarras = ({ data = {} }) => {

    return <Bar data={data} options={options} />
}
export default GraficaBarras